module.exports = __webpack_public_path__ + "static/media/ellipsis.a0d3297d.svg";